import React from 'react'
import SubscriptionsPageLayout from 'container/SubscriptionsPageLayout'

const Subscriptions: React.FC = () => {
	return <SubscriptionsPageLayout />
}

export default Subscriptions
